import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import WhatWeDoSection from "./components/WhatWeDoSection";
import HowWeDoItSection from "./components/HowWeDoItSection";
import WhyPryshSection from "./components/WhyPryshSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import ContactPage from "./pages/ContactPage";

const HomePage = () => {
  return (
    <div className="bg-black min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <WhatWeDoSection />
        <HowWeDoItSection />
        <WhyPryshSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App bg-black min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
